export default {
  journey_management: ['journey_management']
  // trip_add: ['trip_add'],
  // trip_edit: ['trip_edit'],
  // trip_status: ['trip_edit'],
  // trip_delete: ['trip_delete'],
  // trip_archive: ['trip_archive']
}
